<mat-card appearance="outlined" class="mat-elevation-z4"
	[ngClass]="{'success-background' : preivousStatus === 'Approved', 'danger-background': (preivousStatus === 'Denied' || preivousStatus === 'Ineligible' || preivousStatus === 'Voided')}">
	<mat-card-content>
		<div class="row row-cols-sm-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-3">
			<div class="col">
				<mat-label><b>{{header}}</b></mat-label>
			</div>
			<div class="col">
				<mat-label><b>Status: {{currentStatus + (preivousStatus ? ' (' + preivousStatus + ')' :
						'')}}</b></mat-label>

			</div>
			<div class="col" style="text-align: right;">
				<app-node-control *ngIf="node" [(node)]="node"></app-node-control>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<div class="row margin-top-lg">
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="node?.ID">
		<div *ngIf="node?.NODE_CREATORS?.length > 0">
			<i class="fa fa-user"></i>
			&nbsp; Created by
			<span class="bind-color bold">{{node?.NODE_CREATORS[0]?.LOGIN_DETAILS.PERSON.FIRST_NAME}}
				{{node?.NODE_CREATORS[0]?.LOGIN_DETAILS.PERSON.MIDDLE_INITIAL}}
				{{node?.NODE_CREATORS[0]?.LOGIN_DETAILS.PERSON.LAST_NAME}}
				({{node?.NODE_CREATORS[0]?.LOGIN_DETAILS.USER_ID}})</span>
		</div>
		<div *ngIf="node?.NODE_EDITING?.length > 0">
			<i class="fa fa-pencil"></i>
			&nbsp; Current Editor:
			<span class="bind-color bold">{{node?.NODE_EDITING[0]?.LOGIN_DETAILS.PERSON.FIRST_NAME}}
				{{node?.NODE_EDITING[0]?.LOGIN_DETAILS.PERSON.MIDDLE_INITIAL}}
				{{node?.NODE_EDITING[0]?.LOGIN_DETAILS.PERSON.LAST_NAME}}
				({{node?.NODE_EDITING[0]?.LOGIN_DETAILS.USER_ID}})</span>
		</div>
		<div *ngIf="node?.NODE_REGIONS[0]?.REGION.ID">
			<i class="fa fa-globe"></i>
			&nbsp; Region:
			<span class="bind-color bold">{{node?.NODE_REGIONS[0]?.REGION.ORGANIZATION.NAME}}
				({{node?.NODE_REGIONS[0]?.REGION.CODE}})</span>
		</div>
	</div>
</div>

<div *ngIf="nodeHistories && nodeHistories.length > 0">
	<div class="row">
		<div class="col-sm-1"></div>
		<div class="col-sm-9" (click)="showHistory = !showHistory">
			<div *ngFor="let history of nodeHistories; let first = first; let last = last;" class="cursor-pointer">
				<div class="row" *ngIf="nodeHistories.length > 0 && showHistory && !last">
					<!-- *ngIf="showHistory && !last"-->
					<div class="col">
						<span class="default-color">
							({{history?.WORKFLOW_STATE_TYPES?.DESCRIPTION}}
						</span>
						<span class="fa fa-arrow-right"></span>
						<span class="default-color">
							{{history?.WORKFLOW_STATE_TYPES1?.DESCRIPTION}}
						</span>
						<span> ) by</span>
						<span *ngIf="history?.LOGIN_DETAILS?.ID" class="bind-color bold">
							{{history.LOGIN_DETAILS.PERSON.FIRST_NAME}}
							{{history.LOGIN_DETAILS.PERSON.MIDDLE_INITIAL}} {{history.LOGIN_DETAILS.PERSON.LAST_NAME}}
							({{history.LOGIN_DETAILS.USER_ID}})
						</span>
						<span *ngIf="!history?.LOGIN_DETAILS?.ID" class="bind-color bold">---</span>
						<span>
							({{history.CREATED_DATE | cleanDate | simpleDateTime: 'MMM dd, YYYY @ h:mm a' }})
						</span>
						<span *ngIf="!showHistory && last" class="fa fa-chevron-down"></span>
						<span *ngIf="showHistory && first" class="fa fa-chevron-up"></span>
					</div>
				</div>
				<div class="row" *ngIf="nodeHistories.length > 0 && last">
					<div class="col">
						<span class="default-color">
							({{history?.WORKFLOW_STATE_TYPES?.DESCRIPTION}}
						</span>
						<span class="fa fa-arrow-right"></span>
						<span class="status-color">
							{{history?.WORKFLOW_STATE_TYPES1?.DESCRIPTION}}
						</span>
						<span> ) by</span>
						<span *ngIf="history?.LOGIN_DETAILS?.ID" class="bind-color bold">
							{{history.LOGIN_DETAILS.PERSON.FIRST_NAME}}
							{{history.LOGIN_DETAILS.PERSON.MIDDLE_INITIAL}} {{history.LOGIN_DETAILS.PERSON.LAST_NAME}}
							({{history.LOGIN_DETAILS.USER_ID}})
						</span>
						<span *ngIf="!history?.LOGIN_DETAILS?.ID" class="bind-color bold">---</span>
						<span>
							({{history.CREATED_DATE | cleanDate | simpleDateTime: 'MMM dd, YYYY @ h:mm a' }})
						</span>
						<span *ngIf="!showHistory && last" class="fa fa-chevron-down"></span>
						<span *ngIf="showHistory && first" class="fa fa-chevron-up"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div style="height: 15px;"></div>